import { Map } from 'immutable';

import * as ActionTypes from '../constants/ActionTypes';

import Person from '../model/Person';

import { AdviceArea } from '../constants/AdviceArea';
import { DefaultServices } from '../constants/DefaultServices';
import { HeadlineAdviserTypes } from '../content/HeadlineContent';

const initialState = Map({
    loading: false,
    error: false,
    errorMessage: '',

    submitted: false,

    person: new Person(),
});

const reducer = function reducer(state = initialState, action) {
    if (action.type === ActionTypes.RESET) {
        return initialState.merge(Map({
            loading: false,
            error: false,
            errorMessage: '',

            submitted: false,

            person: new Person(),
        }));
    }

    if (action.type === ActionTypes.UPDATE_PERSON_ATTRIBUTE) {
        const newData = state.get('person').set(action.attributeName, action.value);
        const newState = Map({
            person: new Person(newData),
        });

        return state.merge(newState);
    }

    if (action.type === ActionTypes.START) {
        const newState = Map({
            started: true,
        });

        return state.merge(newState);
    }

    if (action.type === ActionTypes.INITIALISE_URL_QUERY_DATA) {
        if (!action.query) {
            return state;
        }

        const adviceArea = HeadlineAdviserTypes[action.query.vf_adviser_type] ?
            HeadlineAdviserTypes[action.query.vf_adviser_type].value : null;

        let person = state.get('person');
        if (adviceArea) {
            const newData = person.set('adviceArea', adviceArea);
            person = new Person(newData);
        }

        const newState = Map({
            adviserType: action.query.vf_adviser_type,
            consumerLocation: action.query.vf_consumer_location,
            person,
        });

        return state.merge(newState);
    }

    if (action.type === ActionTypes.CREATE_MESSAGE) {
        const person = state.get('person');

        let otherAdviceAreas = '';
        if (person.get('otherAdviceAreas')) {
            let delimiter = ',';
            for (let i = 0; i < person.get('otherAdviceAreas').length; i++) {
                const otherAdviceArea = person.get('otherAdviceAreas')[i];
                if (!AdviceArea[otherAdviceArea]) {
                    continue;
                }

                if (i === person.get('otherAdviceAreas').length - 1) {
                    delimiter = ' and';
                }

                otherAdviceAreas += `${delimiter} ${AdviceArea[otherAdviceArea]}`;
            }
        }

        let message = 'Hello, \n\n' +
            `I am looking for help with ${DefaultServices.get(person.get('needKey')).get('name')}. \n\n`;

        if (person.get('adviceArea') === 392) {
            message += 'The value of the property I\'m looking to ';
            message += `${(person.get('needKey') === 'remortgaging') ? 'remortgage ' : 'buy '}`;
            message += `is ${person.get('mortgageValue')}. \n\n`;
            message += `I am looking to do this in ${person.get('adviceTime')}. \n\n`;
            message += `I have an annual income of ${person.get('annualIncome')} `;
            message += `and a deposit of ${person.get('deposit')}. \n\n`;
        } else {
            message += `I have ${person.get('wealthLevel')} in savings, investments & pensions. \n\n`;
        }

        message += 'I am also keen to understand the costs associated with this advice.';

        const newData = person.set('message', message);

        return state.merge({ person: new Person(newData) });
    }

    if (action.type === ActionTypes.SUBMIT_SUCCESS) {
        const newState = Map({
            submitted: true,
            error: false,
            errorMessage: '',
        });

        return state.merge(newState);
    }

    if (action.type === ActionTypes.SUBMIT_ERROR) {
        const newState = Map({
            submitted: false,
            error: true,
            errorMessage: 'An error occurred while sending your data. Please try again in a few seconds.',
        });

        return state.merge(newState);
    }

    if (action.type === ActionTypes.SUBMIT_NEWSLETTER_SUCCESS) {
        const newState = Map({
            newsletterEmailSent: true,
        });

        return state.merge(newState);
    }

    return state;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/default.js